import React from "react";
import { ProjectTearsheetProvider } from "../tearsheets/project/project-tearsheet";
import { AssignmentTearsheetProvider } from "../tearsheets/assignment/assignment-tearsheet";
import { RequestTearsheetProvider } from "../tearsheets/request/request-tearsheet";
import type { TableApi } from "@procore/data-table";
import { PersonTearsheetProvider } from "./people/people-tearsheet";

export default function TearsheetProvider({
   children,
   projectsTableApi,
}: {
   children: React.ReactNode;
   projectsTableApi?: TableApi;
}) {
   // ProjectTearsheetProvider must be outermost because PersonTearsheetProvider
   // uses useProjectTearsheet() to open Project details tearsheet from Person tearsheet
   const providers = [
      PersonTearsheetProvider,
      RequestTearsheetProvider,
      AssignmentTearsheetProvider,
      ProjectTearsheetProvider,
   ];

   // Wrap the children in each provider so that all Tearsheets are accessible through this one provider.
   return providers.reduce((acc, Provider) => {
      return (
         <Provider
            projectsTableApi={projectsTableApi}
            peopleTableApi={undefined}
            assignmentTableApi={undefined}
            requestTableApi={undefined}
         >
            {acc}
         </Provider>
      );
   }, children);
}

// and now this component will be able to access all the methods of the providers.
// <TearsheetProvider>
//    <Component></Component>
// </TearsheetProvider>
